import { Injectable, Optional, SkipSelf } from "@angular/core";

// Ce service sert a maintenir la connaissance des pop-up ouvertes
// Il est utilise pour eviter des problems tels que le bugs 54315,
// qui se produit si on ouvre deux pop-up Bootstrap en meme temps
@Injectable({ providedIn: 'root' })
export class BootstrapPopupService {
	private currentPopupId: string | null = null;

	constructor( //
		@Optional() @SkipSelf() previousInstance?: BootstrapPopupService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded.');
		}
	}
	
	public getCurrentPopupId(): string | null {
		return this.currentPopupId;
	}
	
	public setCurrentPopupId(id: string | null) {
		this.currentPopupId = id;
	}
}